import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './assets/locales/en/translation.json';
import translationAR from './assets/locales/ar/translation.json';

const fallbackLng = ['en'];
const availableLanguages = ['en', 'ar'];

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    supportedLngs: availableLanguages,

    detection: {
      // Translation resources are bundled; never build a network URL from a
      // detected language value.
      caches: [],
    },

    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
